export default {
    path : "land-item-allsuccess",
    name : "land-item-allsuccess",
    meta : {
        title : "关注项目"
    },
    component: () => import('@/pages/land/allsuccess/Index'),
    redirect: {
        name : "land-item-allsuccess-whole"
    },
    children: [
        {
            path: 'all',
            name: 'land-item-allsuccess-whole',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'land-item-allsuccess-recent',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'land-item-allsuccess-atme',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'land-item-allsuccess-meat',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'land-item-allsuccess-reply',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'land-item-allsuccess-search',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/land/allsuccessitem/index.js